<script>
  import {getContext, onMount} from 'svelte';
  import {fly} from 'svelte/transition';
  import {FaqOptions} from '@/modules/homepage/constants';
  import lang from '../HomePage.lang';

  const LG = getContext('LG');

  let showStatus = [];

  onMount(() => {
    showStatus = FaqOptions.map((_, index) => false);
  });

  function handleShow(index) {
    return () => {
      showStatus[index] = !showStatus[index];
    };
  }

  function handleMatchMap({content, linkTxt, markName, linkUrl}) {
    let txts = [];
    let links = [];
    let names = []
    if (Array.isArray(linkTxt)) {
      txts = linkTxt;
      links = linkUrl;
      names = markName;
    } else {
      txts = [linkTxt];
      links = [linkUrl];
      names = [markName];
    }
    const mark = {};
    txts.forEach((tx, index) => {
      mark[names[index]] = `<a class="TW cp link-a" href=${links[index]} rel="noopener noreferrer nofollow">${LG(tx)}</a>`;
    });
    if (Object.keys(mark).length > 0) {
      return LG(content, {...mark});
    }
    return LG(content);
  }
</script>

<style lang="scss">
  .wrap {
    margin: 0 auto 60px;
    box-sizing: border-box;
    width: 1200px;
    height: auto;
    .title {
      margin: 0;
    }
    .c-gray {
      color: #888b94;
    }
    :global(.link-a) {
      &:hover {
        color: #fff;
        opacity: 0.8;
      }
    }
    :global(.text-line) {
      text-decoration: underline;
    }
    .content {
      & + .content {
        margin-top: 48px;
      }
      & > h4 {
        margin: 0;
      }
    }
    .drop-arrow {
      transform: rotate(0deg);
      -moz-transform: rotate(0deg); /* Firefox */
      -webkit-transform: rotate(0deg);
      transition: all 0.2s ease-in-out;
    }
    .animation {
      transform: rotate(180deg);
      -moz-transform: rotate(180deg); /* Firefox */
      -webkit-transform: rotate(180deg); /* Safari 和 Chrome */
      transition: all 0.2s ease-in-out;
    }
    .gap-12 {
      gap: 12px;
    }
    .hidden {
      visibility: hidden; /* 隐藏元素，但保留空间 */
      opacity: 0; /* 使元素透明 */
      height: 0;
      margin-top: 0;
    }
    .content-txt {
      transition: all 0.3s ease; /* 平滑过渡 */
    }
    .faq-box {
      margin-top: 56px;
    }
  }
  @media screen and (max-width: 640px) {
    .wrap {
      margin: 40px 0 20px;
      padding: 0 16px;
      width: 100%;
      .faq-box {
        margin-top: 40px;
      }
      .title {
        font-size: 18px;
      }
      .content {
        & + .content {
          margin-top: 24px;
        }
        h4 {
          flex-wrap: nowrap;
          & > span {
            font-size: 14px;
          }
          & > i {
            font-size: 14px;
          }
        }
        .content-txt {
          margin-top: 8px;
          padding-right: 20px;
          line-height: 14px;
          font-size: 12px;
        }
      }
    }
  }
</style>

<div class="wrap TW">
  <h1 class="title tc f32 fw4">{LG(lang.FaqTitle__New)}</h1>
  <div class="faq-box">
    {#each FaqOptions as faq, index}
      <div class="content">
        <h4 class="df jcsb aic fw1 f22 cp gap-12" on:click={handleShow(index)}>
          <span>{LG(faq.title)}</span>
          <i class="iconfont drop-arrow dib ml4 f22 fw3" class:animation={showStatus[index]}>&#xe756;</i>
        </h4>
        <!--{#if showStatus[index]}-->
          <div class="mt12 c-gray f16 fw1 lh22 content-txt" class:hidden={!showStatus[index]} transition:fly={{duration: 160}}>
            {#if Array.isArray(faq.content)}
              {#each faq.content as text}
                {#if Array.isArray(text)}
                  <ul>
                    {#each text as txt}
                      {#if txt.linkTxt && txt.linkUrl}
                        <li>
                          {@html handleMatchMap(txt)}
                        </li>
                      {:else}
                        <li>{LG(txt)}</li>
                      {/if}
                    {/each}
                  </ul>
                {:else}
                  <div>{LG(text)}</div>
                {/if}
              {/each}
            {:else if faq.linkTxt && faq.linkUrl}
              <span>{@html handleMatchMap(faq)}</span>
            {:else}
              <span>{LG(faq.content)}</span>
            {/if}
          </div>
        <!--{/if}-->
      </div>
    {/each}
  </div>
</div>
